import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext, useState } from 'react';

import FlexColumn from '@ui/atoms/FlexColumn';
import LoadingWrapper from '@ui/atoms/LoadingWrapper';
import Skeleton from '@ui/atoms/Skeleton';

import CenteredGridItem from '@ui/molecules/CenteredGridItem';

import useFetchPhoto from '@hooks/useFetchPhoto';

import { exists } from '@utils/general';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';

import MemberUploadIdStep, { IMemberUploadIdStepProps } from './MemberUploadIdStep.component';

interface IMemberUploadIdStepPageProps extends IFlowStepProps {}

const MemberUploadIdStepPage: FC<IMemberUploadIdStepPageProps> = ({ path, stepKey }) => {
	const [loading, setLoading] = useState(true);

	const { handleNavNext } = useContext(FlowContext);

	useFetchPhoto({
		imageType: 'Photo ID',
		handleError: () => setLoading(false),
		callback: (photo) => (exists(photo) ? handleNavNext(stepKey) : setLoading(false)),
	});

	const { pageContent } = useStaticQuery<IMemberUploadIdStepProps>(
		graphql`
			{
				pageContent: butterPage(slug: { eq: "upload-id" }) {
					title
					main_content
					upload_id_title
				}
			}
		`
	);

	const skeleton = (
		<CenteredGridItem>
			<FlexColumn gap="xxxl">
				<FlexColumn gap="md">
					<Skeleton structure="single" height="lgxl" fullWidth />
					<Skeleton structure="column" repeated={4} gap="xs" height="sm" fullWidth />
				</FlexColumn>
				<FlexColumn gap="sm">
					<Skeleton structure="single" height="lg" fullWidth />
					<Skeleton structure="single" height="xxxl" fullWidth />
				</FlexColumn>
			</FlexColumn>
		</CenteredGridItem>
	);

	return (
		<LoadingWrapper skeleton={skeleton} loading={loading}>
			<MemberUploadIdStep path={path} stepKey={stepKey} pageContent={pageContent} />
		</LoadingWrapper>
	);
};

export default MemberUploadIdStepPage;
